import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { Avatar } from 'primeng/avatar';
import { Card } from 'primeng/card';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface CardWrapperProps extends FormlyFieldProps {
  badge?: {
    icon: string;
    severity?: string;
  };
  backgroundColor?: string;
  styleClass?: string;
  topMargin?: string;
  title?: string;
}

@Component({
  schemas: [NO_ERRORS_SCHEMA],
  selector: 'card-wrapper-primeng-form-field',
  standalone: true,
  imports: [CommonModule, ...FORM_IMPORTS, Card, Avatar],
  template: `
    <div class="flex flex-col items-center w-full {{ props.topMargin }}">
      @if (props.badge) {
        <div class="z-10">
          <p-avatar
            class="{{ props.badge.severity ?? 'accent' }}"
            [icon]="props.badge.icon"
            size="xlarge"
            shape="circle"
          />
        </div>
      }
      <p-card
        [header]="props.title ?? ''"
        class="
          w-full 
          {{
          props.badge ? ' -mt-[calc(var(--p-avatar-xl-height)_/_2)] ' : ' '
        }}
          {{ props.badge ? 'pt-[calc(var(--p-avatar-xl-height)_/_2)] ' : ' ' }}
          {{ (props.backgroundColor ?? 'bg-aquamarine-500') + ' ' }}
          {{ props.styleClass + ' ' }}
          {{ field.className + ' ' }}
        "
      >
        <ng-container #fieldComponent></ng-container>
      </p-card>
    </div>
  `,
})
export class CardWrapperFormField extends FieldWrapper<
  FormlyFieldConfig<CardWrapperProps>
> {}
